import { render } from "./VODVideoModal.vue?vue&type=template&id=1fbb799a&scoped=true"
import script from "./VODVideoModal.vue?vue&type=script&lang=js"
export * from "./VODVideoModal.vue?vue&type=script&lang=js"

import "./VODVideoModal.vue?vue&type=style&index=0&id=1fbb799a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1fbb799a"]])

export default __exports__